import React from 'react';
import caexSustentable from 'img/caex_sustentable.png';
import HelpContent from './HelpContent';

/*
 * Ayuda para reemplazo de tecnologías en transporte minero.
 */

const ReemplazoTransporteMineriaHelp = () => (
  <HelpContent>
    <h1>Reemplazo de tecnologías en transporte minero</h1>
    <img src={caexSustentable} alt="Camión CAEX sustentable en faena minera" />
    <label>Figura: Camión CAEX sustentable operando en una faena minera.</label>
    <p>
      La medida tiene como objetivo promover soluciones que faciliten la transición de los vehículos pesados utilizados en la industria minera,
      actualmente dependientes de combustibles fósiles, hacia operaciones basadas en energías sustentables, como la electricidad,
      el hidrógeno o sistemas híbridos y el fomento del uso del diésel renovable. En este contexto,
      la definición de camiones CAEX sustentables se refiere a cualquier tecnología que permita reducir el consumo diésel parcial o totalmente,
      entre ellas: camiones híbridos que mezclan diésel con gas natural, camiones híbridos que utilizan diésel y baterías,
      camiones que usan sistemas de trolley para moverse parcialmente en algún tramo de la mina, camiones que usan baterías y
      sistema de trolley y camiones a hidrógeno.
    </p>
    <p>
      Dado el alto nivel de incertidumbre respecto a las tecnologías que se desarrollarán en el futuro,
      la medida no se enfoca en especificar una tecnología en particular.
      Lo fundamental es lograr las reducciones de emisiones,
      independientemente de la solución adoptada por cada empresa dentro del sector de la minería del cobre.
    </p>
    <p>
      <strong>Trayectoria 1:</strong>
    </p>
    <p>
      Diésel renovable: participación de diésel renovable de 5% al año 2030 llegando a 10% en 2035, manteniendo constante la participación hasta 2050.
    </p>
    <p>
      Camiones sustentables: penetración de 40% de camiones híbridos y 5% eléctricos en 2035 aumentando la participación de camiones eléctricos a 90% en 2050.
    </p>
  </HelpContent>
);

export default ReemplazoTransporteMineriaHelp;
